"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionBar = exports.ActionItem = exports.ActionButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var Container =
/*#__PURE__*/
(0, _styled.default)("ul", {
  target: "egs2kzf0"
})(function (_ref) {
  var theme = _ref.theme;
  return {
    position: 'absolute',
    bottom: 0,
    right: 0,
    maxWidth: '100%',
    display: 'flex',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    borderTop: theme.mainBorder,
    borderLeft: theme.mainBorder,
    background: theme.barFill,
    borderRadius: "".concat(theme.mainBorderRadius, "px 0 0 0")
  };
});
var ActionButton =
/*#__PURE__*/
(0, _styled.default)("button", {
  target: "egs2kzf1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return {
    border: '0 none',
    display: 'block',
    background: 'none',
    padding: '0 10px',
    textTransform: 'inherit',
    letterSpacing: 'inherit',
    fontSize: 'inherit',
    color: 'inherit',
    borderTop: '2px solid transparent',
    borderBottom: '2px solid transparent',
    '&:focus': {
      borderBottom: "2px solid ".concat(theme.highlightColor),
      outline: '0 none'
    }
  };
});
exports.ActionButton = ActionButton;
ActionButton.displayName = 'ActionButton';
var ActionItem =
/*#__PURE__*/
(0, _styled.default)("li", {
  target: "egs2kzf2"
})(function (_ref3) {
  var first = _ref3.first,
      theme = _ref3.theme;
  return {
    display: 'flex',
    position: 'relative',
    listStyle: 'none',
    padding: 0,
    height: 26,
    fontSize: 11,
    letterSpacing: 1,
    textTransform: 'uppercase',
    borderLeft: first ? '0 none' : "1px solid ".concat(theme.mainBorderColor)
  };
});
exports.ActionItem = ActionItem;
ActionItem.displayName = 'ActionItem';

var ActionBar = function ActionBar(_ref4) {
  var children = _ref4.children;
  return _react.default.createElement(Container, null, _react.Children.toArray(children).map(function (item, index) {
    return (// eslint-disable-next-line react/no-array-index-key
      _react.default.createElement(ActionItem, {
        key: index,
        first: index === 0
      }, item)
    );
  }));
};

exports.ActionBar = ActionBar;
ActionBar.propTypes = {
  children: _propTypes.default.node.isRequired
};